import { defineRecipe } from '@plurall/elo-v3';

export const schoolSelectorRootRecipe = defineRecipe({
  className: 'school-selector-root',
  base: {
    width: '100%',

    '& > *': {
      width: '100%',
    },

    '& [data-scope="field"][data-part="root"]': {
      width: '100% !important',
    },
  },
});
